import script from "./UsefulLinksView.vue?vue&type=script&setup=true&lang=js"
export * from "./UsefulLinksView.vue?vue&type=script&setup=true&lang=js"

import "./UsefulLinksView.vue?vue&type=style&index=0&id=2aaef637&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aaef637"]])

export default __exports__